import { useEffect, useState } from "react";
import { Outlet, useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { BASE_URL } from "../config/environments";
import { useCard } from "../context/CardContext"

export default function CardRouter() {
    const { cardData, updateCardData } = useCard();
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const location = useLocation();
    const [error, setError] = useState("");

    const rawToken = params.get("q") || params.get("token");
    const token = rawToken || null;
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        // CardRouter should only handle the root route
        if (location.pathname !== "/") {
            setLoading(false);
            return;
        }

        if (!token) {
            setError("Authorization token is missing.");
            setLoading(false);
            return;
        }

        if (cardData) {
            setLoading(false);
            return;
        }

        const fetchCards = async () => {
            try {
                setLoading(true);
                setError("");

                const response = await fetch(
                    `${BASE_URL}/api/v1/cardFormDetails`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error(`Server error: ${response.status}`);
                }

                const result = await response.json();

                updateCardData(result);

                if (
                    result?.userCardInfo &&
                    result.userCardInfo.length > 0
                ) {
                    navigate(`/viewcardpage/?q=${token}`);
                } else {
                    navigate(`/addcard/?q=${token}`);
                }

            } catch (error) {
                console.error("Router API Error:", error);
                setError("Unable to load card details. Please try again.");
            } finally {
                setLoading(false);
            }
        };

        fetchCards();

    }, [
        token,
        cardData,
        navigate,
        location.pathname,
        updateCardData
    ]);
    if (error) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="text-center text-red-600">
                    {error}
                </div>
            </div>
        );
    }
    return (
        <>
            {loading ? (
                <div className="flex justify-center items-center h-screen">
                    Loading...
                </div>
            ) : (
                <Outlet context={{ token }} />
            )}
        </>
    );
}